export default function PropertyBackgroundImage({ propertyData }) {

  // Desktop Image
  const desktopBgImage =
    propertyData?.images?.find(
      (img) => !img.isMobile && img.propertyImage
    )?.propertyImage || "/images/banner.png";

  // Mobile Image
  const mobileBgImage =
    propertyData?.images?.find(
      (img) => img.isMobile && img.propertyImage
    )?.propertyImage || "/images/banner.png";

  // Desktop Video
  const desktopVideo =
    propertyData?.images?.find(
      (img) => img.propertyVideoName
    )?.propertyVideoName || "";

  // Mobile Video
  const mobileVideo =
    propertyData?.images?.find(
      (img) => img.mobileVideoURL
    )?.mobileVideoURL || "";

  return (
    <>
      <div className="banner-bg">
        {/* Desktop View */}
        {desktopVideo ? (
          <video
            className="banner-video desktop-video"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src={desktopVideo} type="video/mp4" />
          </video>
        ) : (
          <div
            className="banner-image desktop-image"
            style={{
              backgroundImage: `url(${desktopBgImage})`,
            }}
          />
        )}

        {/* Mobile View */}
        {mobileVideo ? (
          <video
            className="banner-video mobile-video"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src={mobileVideo} type="video/mp4" />
          </video>
        ) : (
          <div
            className="banner-image mobile-image"
            style={{
              backgroundImage: `url(${mobileBgImage})`,
            }}
          />
        )}
      </div>

      <style jsx>{`
        .banner-bg {
          position: relative;
          width: 100%;
          height: 100vh;
          overflow: hidden;
        }

        .banner-video,
        .banner-image {
          width: 100%;
          height: 100%;
        }

        .banner-video {
          object-fit: cover;
        }

        .banner-image {
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }

        .desktop-video,
        .desktop-image {
          display: block;
        }

        .mobile-video,
        .mobile-image {
          display: none;
        }

        @media (max-width: 768px) {
          .desktop-video,
          .desktop-image {
            display: none;
          }

          .mobile-video,
          .mobile-image {
            display: block;
          }
        }
      `}</style>
    </>
  );
}